module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<select id="' +
((__t = (id)) == null ? '' : __t) +
'" class="DescartesUISelect form-control">\n    ';

        _.each(scales,function(scale) {
            print('<option value="'+ scale.value +'">' + scale.label + '</option>');
        })
    ;
__p += '\n</select>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/ScaleSelector.ejs
// module id = 414
// module chunks = 0